import TextInput from "@scripts/react/components/TextInput";
import { useModel } from "@/contexts/ModelContext";
import { useComputedValues } from "@/contexts/ComputedValuesContext";
import { useIsGeneratingPredictions } from "@/hooks/useIsGeneratingPredictions";

export const TextPrompt = () => {
    const { textPromptStr, setTextPromptStr } = useModel();
    const isGeneratingPredictions = useIsGeneratingPredictions();
    const { currentFramePredictions } = useComputedValues();

    return (
        <TextInput
            placeholder="Enter objects: person, card, dog..."
            disabled={isGeneratingPredictions || currentFramePredictions.length > 0}
            value={textPromptStr}
            onChange={setTextPromptStr}
            fullWidth={true}
        />
    );
};
